import { Flex, Image, Box } from "theme-ui";
import { ExitButton } from "./ExitButton";
import { BackButton } from "./BackButton";
import JunctionLogo from "../images/junction_logo.svg";

const sideSlotSx = {
  width: 44,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
};

export const Header: React.FunctionComponent<{
  showBack: boolean;
  onBack?: () => void;
  onClose: () => void;
  hideExitButton: boolean;
}> = ({ showBack, onBack, onClose, hideExitButton }) => (
  <Flex
    sx={{
      alignItems: "center",
      width: "100%",
      px: 4,
      py: 3,
      flexDirection: "row",
      borderBottom: "1px solid",
      borderColor: "border",
      bg: "background",
    }}
  >
    <Box sx={{ ...sideSlotSx, justifyContent: "flex-start" }}>
      {showBack && onBack && <BackButton onBack={onBack} />}
    </Box>
    <Flex
      sx={{
        flex: "1 1 auto",
        justifyContent: "center",
        alignItems: "center",
        minWidth: 0,
      }}
    >
      <Image src={JunctionLogo} sx={{ width: 80, height: 24 }} alt="Junction" />
    </Flex>
    <Box sx={{ ...sideSlotSx, justifyContent: "flex-end" }}>
      {!hideExitButton && <ExitButton onClose={onClose} />}
    </Box>
  </Flex>
);
